import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { Subscription } from 'rxjs';
import { EventForPlanningDto } from '../../../../shared/models/calendar/event-for-planning.dto';
import { GetLeadEventsFilter } from '../../../../shared/models/calendar/get-lead-events.filter';
import { GetLeadEventsInput } from '../../../../shared/models/calendar/get-lead-events.input';
import { RemoveEventInput } from '../../../../shared/models/calendar/remove-event.input';
import { CalendarComuService } from '../../../../shared/services/calendar/calendar-comu.service';
import { CalendarService } from '../../../../shared/services/calendar/calendar.service';
import { ToastService } from '../../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';

@Component({
  selector: 'ngx-planning-reminder',
  templateUrl: './planning-reminder.component.html',
  styleUrls: ['./planning-reminder.component.scss']
})
export class PlanningReminderComponent implements OnInit, OnDestroy {
  @Input() leadId: string;
  getLeadEventsFilter: GetLeadEventsFilter;
  showAllHoursFlag: any;
  events: EventForPlanningDto[];
  removeEventInput = new RemoveEventInput();
  alive: boolean;
  @ViewChild('fullcalendar', { static: true })
  fullcalendar: FullCalendarComponent;
  refreshScheduleSubcription: Subscription;
  searchPlanningEventsSubcription: Subscription;
  loadedEvents = false;
  removingEvent = false;

  constructor(private readonly calendarService: CalendarService,
    private readonly calendarComuService: CalendarComuService,
    private readonly cdr: ChangeDetectorRef,
    private readonly toastService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
  ) {
    this.getLeadEventsFilter = new GetLeadEventsFilter();
    this.events = [];
  }
  ngOnInit(): void {
    this.getEvents();
    this.refreshScheduleSubcription = this.leadComuService.reloadMyLead.subscribe(() => {
      this.getScheduleEvents();
    });
  }

  ngOnDestroy(): void {
    if (this.searchPlanningEventsSubcription) {
      this.searchPlanningEventsSubcription.unsubscribe();
    }
    if (this.refreshScheduleSubcription) {
      this.refreshScheduleSubcription.unsubscribe();
    }
  }

  isToday(dateEventRaw) {
    const dateEvent = new Date(parseInt(dateEventRaw, 10)).getDate();
    return dateEvent === new Date(Date.now()).getDate();
  }

  isPast(dateEventRaw) {
    return Date.now() > parseInt(dateEventRaw, 10);
  }

  notAttended(dateEventRaw, dateEventLead, dateEventInit, leadStatus): boolean {
    if (leadStatus !== 'archived' && leadStatus !== 'closed') {
      return Date.now() > parseInt(dateEventRaw, 10) && Date.now() > (parseInt(dateEventLead, 10)) && parseInt(dateEventInit, 10) === (parseInt(dateEventLead, 10));
    }
  }
  private getLeadEventsForDay(getLeadEventsFilter) {
    getLeadEventsFilter.isPlanningReminder = true;

    this.calendarService.getEventsForDay$(getLeadEventsFilter).subscribe(events => {
      this.events = events;
      this.cdr.detectChanges();
      this.removingEvent = false;
    });
  }

  removeEvent(event): void {
    this.removingEvent = true;
    const eventRemovedInput = new RemoveEventInput();
    eventRemovedInput.eventId = event.id;
    eventRemovedInput.leadId = event.leadId;
    this.calendarComuService.removeEventFromReminders(eventRemovedInput);
    if (!this.leadId) {
      this.getLeadEventsForDay(this.getLeadEventsFilter);
    } else {
      this.calendarService.removeEvent$(eventRemovedInput).subscribe(removed => {
        if (removed) {
          this.calendarComuService.activateInteraction.emit(true);
          this.getScheduleEvents();
          this.toastService.showToast(
            'success',
            'toaster.title.lead_remove_event_success',
            'toaster.lead_remove_event_success'
          );
        }
      });
    }
  }

  private getEvents() {
    if (!this.leadId) {
      this.searchPlanningEventsSubcription = this.calendarComuService.searchPlanningEvents.subscribe(res => {
        this.getLeadEventsFilter = res;
        this.getLeadEventsForDay(this.getLeadEventsFilter);
        this.loadedEvents = true;
      });
    } else {
      this.getScheduleEvents();
    }
  }

  private getScheduleEvents() {
    const getLeadEventsInput = new GetLeadEventsInput();
    getLeadEventsInput.filter = this.getLeadEventsFilter;
    getLeadEventsInput.filter.dateFrom = new Date();
    getLeadEventsInput.filter.leadId = this.leadId;
    getLeadEventsInput.leadId = this.leadId;
    this.calendarService.getEvents$(getLeadEventsInput).subscribe(events => {
      this.events = events.events;
      this.loadedEvents = true;
      this.removingEvent = false;
    });
  }
}
